const keyVisualSwiper = new Swiper('.swiper.key-visual-swiper', {
    // Optional parameters
    loop: true,
    speed: 2000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 7000,
    },

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
});

const productLineupSwiper = new Swiper('.swiper.product-lineup-swiper', {
    slidesPerView: 1,

    breakpoints: {
        750: {
            slidesPerView: 3,
        }
    },

    // Navigation arrows
    navigation: {
        nextEl: '.product-lineup-navigation.swiper-button-next',
        prevEl: '.product-lineup-navigation.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.product-lineup-swiper-scrollbar.swiper-scrollbar',
        draggable: true,
    },
});

const usersVoiceSwiper = new Swiper('.swiper.users-voice-swiper', {
    slidesPerView: 1.2,
    spaceBetween: "12%",

    breakpoints: {
        750: {
            slidesPerView: 2,
        }
    },

    // Navigation arrows
    navigation: {
        nextEl: '.usesrs-voice-navigation.swiper-button-next',
        prevEl: '.usesrs-voice-navigation.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.users-voice-swiper-scrollbar.swiper-scrollbar',
        draggable: true,
    },
});